import { GetSettingsHierarchyMethod, type SchemaSettingsHierarchy } from '@/shared/api/openApi';
import { transport } from '@/shared/api/transport';
import type { IMerchSettingRepository } from './types/IMerchSettingRepository';
import { type SettingsPartsPaths } from './types';

export const merchSettingRepository: IMerchSettingRepository = {
    getSettingsByPaths: (paths: SettingsPartsPaths[], storeSlug: string): Promise<SchemaSettingsHierarchy> =>
        transport({
            url: `${storeSlug}/settings/describes?${paths.map((path) => `paths=/${path}`).join('&')}`,
            method: GetSettingsHierarchyMethod,
        }),
};
